import React from 'react';
import './Loading.scss';

const Loading = (props) => {
    console.log(props.error)
  return (
    <div className="loading-page-container">
      {
        props.error ? (
          <div>
            <p className="emoji-face">ಠ_ಠ</p>
            <p className="text">网络错误 - <span className="reload-button" role="button" onClick={() => props.retry && props.retry()}>重新加载</span></p>
          </div>
        )
        : props.pastDelay ? <div className="loading"></div> : null
      }
    </div>
  );
}

export default Loading;
